import httpClient from '@xver/libs/axios';

import { ListResponseModel } from './model';

const ENDPOINTS = {
    LIST: '/v1/announcements',
};

export function listAnnouncements(): Promise<ListResponseModel> {
    return httpClient.get(ENDPOINTS.LIST);
}
